// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"457fae5e","213":"44e9cf0c","234":"5dc3359f","239":"51fcd975","653":"a444cfd3","732":"971385f8","844":"d427edc7"}[chunkId] + ".chunk.js";
};